//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import buttonMixin from './buttonMixin.js';

/**
 * KExternalLink creates a styled external link
 */
export default {
  name: 'KExternalLink',
  mixins: [buttonMixin],
  props: {
    /**
     * URL string
     */
    href: {
      type: String,
      required: true,
    },
    /**
     * Specifies that the file is meant to be downloaded, not displayed in a separate tab.
     */
    download: {
      type: String,
      required: false,
    },
    /**
     * If provided, shows a KIcon in front of the text
     */
    icon: {
      type: String,
      required: false,
    },
    /**
     * If provided, shows a KIcon after the text
     */
    iconAfter: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      hovering: false,
    };
  },
  computed: {
    /**
     * If icon is provided, add 8px margin between the icon and the text
     */
    spanStyle() {
      if (this.icon) {
        if (this.isRtl) {
          return { marginRight: '8px' };
        } else {
          return { marginLeft: '8px' };
        }
      } else {
        return {};
      }
    },
  },
};

